import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { addCashflowCategoriesApi, updateCashflowCategoriesApi } from "../apiService";
import { enqueueSnackbar } from "notistack";
import { checkApiStatus, getGlobalCookie } from "../../../../utils";
import { trackActivity } from "../../../../utils/mixpanel";
import { regexConstants } from "../../../../constants/regEx";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";

const CashFlowCategoriesCRU = ({ addEditCashflowCategory, onToggleModal, getResponseBack, modeType }) => {
  const cashflowType = [{ value: 'IN', label: 'Cash-IN' }, { value: 'OUT', label: 'Cash-OUT' }]
  const [data, setData] = useState(addEditCashflowCategory?.type === 'sub' ? { ...addEditCashflowCategory?.data, type: addEditCashflowCategory?.cashflow_type } : addEditCashflowCategory?.data );
  const [error, setError] = useState({});
  const [isLoading, setLoading] = useState(false);
  const sub = addEditCashflowCategory?.type === 'sub' ? 'Sub ' : '';
  const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
  const onAddEditCashFlowCategory = () => {
    let validationInputs = {}
    validationInputs = {
      name: data?.name ? "" : "Please enter Name",
      type: data?.type ? "" : "Please select Cashflow Type"
    }
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      let payload = Object.assign({}, data);
      payload = {
        ...payload,
        parent: addEditCashflowCategory?.parent_id ? addEditCashflowCategory?.parent_id : data?.parent,
        lessor_id: lessorAccess?.id,
      }; 
      setLoading(true);
      if (payload.id) {
        globalPutService(updateCashflowCategoriesApi(), payload)
          .then(async (response) => {
            if (checkApiStatus(response)) {
              onToggleModal();
              getResponseBack();
              setLoading(false);
              enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Edited', { page_title: `Edit CashFlow ${sub}Category`, success_msg: response?.data?.message, item_id: payload?.id, payload: payload, response: response?.data })
            }
            else {
              setLoading(false);
              enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Edited', { page_title: `Edit CashFlow ${sub}Category`, error_msg: response?.data?.message, item_id: payload?.id, payload: payload, response: response?.data })
            }
          })
      }
      else {
        globalPostService(addCashflowCategoriesApi(), payload).then(async (response) => {
          if (checkApiStatus(response)) {
            onToggleModal();
            getResponseBack();
            setLoading(false);
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Added', { page_title: `Add CashFlow ${sub}Category`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
          }
          else {
            setLoading(false);
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, })
            trackActivity('Item Added', { page_title: `Add CashFlow ${sub}Category`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
          }
        })
      }
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} CashFlow ${sub}Category`, error_msg: validationInputs, })
    }
  }
  const onFieldChange = (key, value) => {
    setData({ ...data, [key]: value });
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} CashFlow ${sub}Category`, page_type: page_type, })
  }

  return (
    <Dialog className="add-lease-dialog" maxWidth="md" open={addEditCashflowCategory.modal} fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
        <Typography sx={{ marginLeft: '10px' }}>{`${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Cashflow ${sub}Category`}</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={{ md: 6, xs: 12 }}>
            <TextField
              disabled={modeType === 'view'}
              label='Name'
              size="small"
              variant="outlined"
              value={data?.name || ""}
              onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('name', e.target.value.trimStart()) : e.preventDefault()}
              onFocus={() => setError({ ...error, name: '' })}
              slotProps={{
                inputLabel: { shrink: true }
              }}
              fullWidth
              required
              error={error?.name}
              helperText={error?.name} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <Autocomplete
              disablePortal
              disableClearable
              fullWidth
              options={cashflowType || []}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              value={cashflowType.find(option=> option?.value===data?.type) || null}
              onChange={(e, newValue) => {
                onFieldChange('type', newValue?.value)
              }}
              onFocus={() => setError({ ...error, type: '' })}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Cashflow Type"
                  margin="normal"
                  size="small"
                  fullWidth
                  error={Boolean(error.type)}
                  helperText={error.type}
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              )}
              disabled={modeType !== 'add'||addEditCashflowCategory?.type === 'sub'}
            />
          </Grid>
          {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
            <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
          </Grid> :
            <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                disabled={modeType === 'view'}
                label='Remarks'
                size="small"
                variant="outlined"
                value={data?.remarks ?? ""}
                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('remarks', e.target.value.trimStart()) : e.preventDefault() }}
                slotProps={{
                  inputLabel: { shrink: true }
                }}
                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                fullWidth
                multiline
                rows={3} />
            </Grid>}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ marginRight: '15px' }}>
        <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
        {modeType === "view" ? null :
          <Button className="btn-primary" variant="contained" size="small" onClick={() => { handleItemClicked('Save Button'); onAddEditCashFlowCategory() }}>{isLoading ? <CircularProgress color="inherit" size={25} /> : "Save"}</Button>}
      </DialogActions>
    </Dialog>
  )
}
export default CashFlowCategoriesCRU;